import React from 'react';
import { FaCheck, FaExclamationCircle , FaRegEdit  } from 'react-icons/fa';

export const STATUSES = {
  TECHNICAL_REVIEW: 'technical-review',
  DRAFT: 'draft',
  REVISION_REQUIRED: 'revision-required',
} as const;

export type StatusType = (typeof STATUSES)[keyof typeof STATUSES];

interface StatusBadgeProps {
  status: StatusType;
}

const CheckIcon = FaCheck as React.FC;
const DraftIcon = FaRegEdit as React.FC;
const RevisionRequired = FaExclamationCircle as React.FC;

const statusConfig: Record<StatusBadgeProps['status'], { label: string; color: string; icon: JSX.Element }> = {
  [STATUSES.TECHNICAL_REVIEW]: {
    label: 'Technical Review',
    color: '#78a22f',
    icon: <CheckIcon />,
  },
   [STATUSES.DRAFT]: {
    label: 'Draft',
    color: '#78a22f',
    icon: <DraftIcon  />,
  },
  [STATUSES.REVISION_REQUIRED]: {
    label: 'Revision Required',
    color: '#C43131',
    icon: <RevisionRequired />,
  }
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const config = statusConfig[status];

  return (
    <span
      style={{
        color: config.color,
        border: `1px solid ${config.color}`,
        borderRadius: '999px',
        padding: '4px 12px',
        display: 'inline-flex',
        alignItems: 'center',
        fontWeight: 500,
        gap: '6px',
        fontSize: '0.9rem',
      }}
    >
      {config.icon}
      {config.label}
    </span>
  );
}; 

export default StatusBadge;